<template>
    <footer>
        <ul v-if="sortedCategories" id="category-stats">
            <li v-for="category in sortedCategories" :key="category.id">
                <span class="color-circle" :style="{ backgroundColor: category.color }"> </span>
                <span class="text">
                    {{ Math.round(category.percentage * 100) }}%
                    {{
                        category.terms.name[$locale]
                        /*  TODO : Replace "category.terms.name[$locale]" by the correct trad function when the filed "value" will be in the object   */
                    }}
                </span>
            </li>
        </ul>
        <ul id="components-stats">
            <li v-if="count(allModules) > 0">
                <span> {{ $trad.plano.editor.infoStatistic.modules }} </span>
                <span class="quantity" style="color: #99B8FA">{{ count(allModules) }} </span> <span class="sku">({{ sku(allModules) }} SKU)</span>
            </li>
            <li v-if="count(allShades) > 0">
                <span> {{ $trad.plano.editor.infoStatistic.shades }} </span>
                <span class="quantity" style="color: #FBE520"> {{ count(allShades) }} </span> <span class="sku">({{ sku(allShades) }} SKU)</span>
            </li>

            <li v-if="count(allShelves) > 0">
                <span> {{ $trad.plano.editor.infoStatistic.shelves }} </span>
                <span class="quantity" style="color: #955C98"> {{ count(allShelves) }} </span>
            </li>

            <li v-if="count(allCaddy) > 0">
                <span> {{ $trad.plano.editor.infoStatistic.caddies }} </span>
                <span class="quantity" style="color: #FE7B20"> {{ count(allCaddy) }} </span>
            </li>
        </ul>
    </footer>
</template>

<script>
import PlanoStatsMixin from "@/mixins/PlanoStatsMixin";
import { mapActions, mapMutations } from "vuex";
import componentService from "@/services/component";
import { findAllComponentsSpecByType, COMPONENT_TYPE, getAllModuleIdFromModuleElements } from "@/plano/utils";

export default {
    mixins: [PlanoStatsMixin],
    data: () => ({
        moduleDetailsCache: new Map()
    }),
    watch: {
        config() {
            this.loadModulesDetails();
        }
    },
    methods: {
        ...mapActions("planoStats", ["fetchCategories"]),
        ...mapMutations("planoStats", ["SET_MODULE_DETAILS"]),
        async loadModulesDetails() {
            let allModules = findAllComponentsSpecByType(this.config, [COMPONENT_TYPE.module]);
            this.SET_MODULE_DETAILS(await this.fetchModuleDetails(allModules));
        },
        async fetchModuleDetails(moduleElements) {
            let missingModuleIds = [];
            const moduleIds = [...getAllModuleIdFromModuleElements(moduleElements)];
            for (const moduleId of moduleIds) {
                if (this.moduleDetailsCache.get(moduleId) === undefined) {
                    missingModuleIds.push(moduleId);
                }
            }
            if (missingModuleIds.length > 0) {
                const res = this.fetchModuleDetailsFromApi(missingModuleIds);
                for (const missingModuleId of missingModuleIds) {
                    this.moduleDetailsCache.set(missingModuleId, res.then(moduleDetails => moduleDetails.find(m => m && m.id === missingModuleId)));
                }
            }
            return Promise.all(moduleIds.map(moduleId => this.moduleDetailsCache.get(moduleId)));
        },
        async fetchModuleDetailsFromApi(moduleIds) {
            return componentService.fromIds(moduleIds, {
                brandId: this.plano.brand.id,
                zoneId: this.plano.zone.id,
                campaignId: this.plano.campaign.id
            });
        },
        async fetchAll() {
            await this.fetchCategories();
            this.loadModulesDetails();
        }
    },
    created() {
        this.fetchAll();
    }
};
</script>

<style scoped lang="scss">
@import "../../assets/css/themes";
footer {
    @extend %second-background;
    @extend %primary-text;
    display: flex;
    justify-content: space-between;
    align-content: center;
    padding: 8px 10px;
    height: 40px;

    ul {
        margin: 0;
        padding: 0px;
        list-style: none;

        li {
            display: inline-block;
            margin: 0px 15px;

            & > * {
                display: inline-block;
                vertical-align: middle;
                text-transform: uppercase;
            }
        }
    }

    #components-stats {
        li {
            font-size: 17px;

            .quantity {
                font-size: 18px;
            }

            .sku {
                font-family: "Roboto", sans-serif;
                font-weight: 100;
                font-size: 18px;
            }
        }
    }

    #category-stats {
        span {
            margin: 0px 4px;
            font-family: "Roboto", sans-serif;
            font-weight: 100;
            font-size: 15px;

            &.color-circle {
                width: 25px;
                height: 25px;
                border-radius: 50%;
                border: 1px #fff solid;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// infos-bar.vue?2df43e7a